// Color constants for the application

// Presence indicator colors (used in multiple components)
export const PRESENCE_COLORS = {
  ONLINE: 'rgb(147,220,105)',     // Green for online users
  OFFLINE: '#cccccc',             // Gray for offline users
  UNKNOWN: '#ffaa00',             // Orange for unknown/loading state
  NO_DATA: '#cccccc',             // Gray when no presence data available
};

export const NETSFERE_COLORS = {
  RED: 'rgb(222, 72, 88)',
};